// Import icons for navigation sections
import { Calendar, Clock, Home, Utensils, MapPin, Waves, AlertTriangle, Users, Camera } from 'lucide-react';

// Trip-specific data and information
export const TRIP_DATA = {
  property: {
    name: "🏠 Katie & Kelvin's Beach House",
    address: "📍 Barrier Dunes, Cape San Blas, FL 32456",
    vrbo: "42312",
    details: "🛏️ 3BR/4BA gulf-front townhome with pool 🏊",
    access: {
      gate: "8656 ENTER",
      door: "0612",
      wifi: "4049156521"
    }
  },
  guests: [
    { name: "Katie & Kelvin", dates: "Full week (Sat-Sat)", from: "Dawsonville, GA" },
    { name: "Hannah, Harper & Kendall", dates: "Sun-Fri", from: "Tampa/Lutz" },
    { name: "Kent", dates: "Tue-Fri", from: "Tampa/Lutz" },
    { name: "Ryan & Laura", dates: "Sun evening-Thu/Fri", from: "Alpharetta, GA" },
    { name: "Chip & Gale Schuneman", dates: "Full week (Sat-Sat)", from: "Separate unit" }
  ],
  schedule: [
    {
      date: "Saturday, June 21",
      events: [
        "Arrivals: Katie & Kelvin, Schunemans",
        "9am-1pm: Salt Air Farmers Market in Port St. Joe",
        "Dinner: Pizza from Trading Post (850-229-8775)"
      ]
    },
    {
      date: "Sunday, June 22",
      events: [
        "Hannah & girls arrive from Tampa",
        "Dinner: Fresh Fish 🐟",
        "Sunset at Salinas Park pier"
      ]
    },
    {
      date: "Monday, June 23",
      events: [
        "Ryan & Laura arrive from GA",
        "Beach day!",
        "Dinner: Steaks 🥩 (Katie & Kelvin cook)",
        "Note: Indian Pass CLOSED today"
      ]
    },
    {
      date: "Tuesday, June 24",
      events: [
        "Kent arrives",
        "Possible taco truck at Scallop Republic",
        "Dinner: Lasagna"
      ]
    },
    {
      date: "Wednesday, June 25",
      events: [
        "Full crew day",
        "🌑 NEW MOON - perfect for stargazing!",
        "Dinner: Ryan cooks - Beachified Thai Chicken Enchiladas 🌶️",
        "Two batches: Mild for family + Spicy for Schunemans"
      ]
    },
    {
      date: "Thursday, June 26",
      events: [
        "Possible departure: Ryan & Laura (afternoon)",
        "4:30pm - Leave for dinner",
        "5:30pm - Dinner at Indian Pass Raw Bar (The Original)",
        "Live music by Corey Hall 🎸"
      ]
    },
    {
      date: "Friday, June 27",
      events: [
        "Hannah's family departs",
        "Alternative departure: Ryan & Laura",
        "Dinner: Leftovers/easy meal"
      ]
    },
    {
      date: "Saturday, June 28",
      events: [
        "Katie & Kelvin depart",
        "Schunemans depart",
        "Checkout"
      ]
    }
  ],
  restaurants: [
    {
      name: "🦪 Hunt's Oyster Bar",
      phone: "(850) 227-2285",
      hours: "11 AM - close, 7 days",
      highlights: ["3-cheese jalapeño oysters 🧀", "Pet-friendly patio 🐕", "Laura-friendly options ✅"],
      address: "1937 SR 38, Port St Joe",
      link: "https://www.facebook.com/huntsoysterbarfl"
    },
    {
      name: "🍕 Cape Trading Post",
      phone: "(850) 229-8775",
      hours: "Mon-Thu 7:30am-9pm, Fri-Sat 7:30am-10pm",
      highlights: ["Pizza: $11.99 first, $10.99 additional", "Only liquor store 🍷", "Full grocery 🛒"],
      address: "Cape San Blas Road",
      link: null
    },
    {
      name: "🍺 Indian Pass Raw Bar",
      phone: "Check Facebook",
      hours: "Tues-Sun 12pm-9pm, CLOSED MONDAYS",
      highlights: ["Operating since 1929 📅", "Honor system beer coolers 🍻", "Live music weekends 🎵"],
      address: "Indian Pass",
      link: "https://www.facebook.com/indianpassrawbar"
    },
    {
      name: "🦐 Scallop Republic",
      phone: "Check website",
      hours: "7 days, happy hour 5-6pm",
      highlights: ["Live music 7 nights 🎸", "$1 off drinks at happy hour 🍹", "Dog-friendly 🐶"],
      address: "Cape San Blas",
      link: "https://www.facebook.com/scalloprepublic"
    }
  ],
  safety: {
    beachFlags: [
      { color: "🟢 Green", meaning: "Low hazard, calm conditions" },
      { color: "🟡 Yellow", meaning: "Medium hazard, moderate surf/currents" },
      { color: "🔴 Red", meaning: "High hazard, strong surf/currents" },
      { color: "🔴🔴 Double Red", meaning: "Water closed to public" },
      { color: "🟣 Purple", meaning: "Dangerous marine life" }
    ],
    ripCurrents: [
      "DON'T PANIC - Stay calm",
      "DON'T swim straight back to shore",
      "DO swim PARALLEL to shore",
      "Float if too tired to swim",
      "Wave and yell for help"
    ],
    flagLocations: [
      "North Fire Station on Cape San Blas",
      "South Fire Station on Cape San Blas", 
      "Barrier Dunes primary walk-over",
      "Online: facebook.com/sgcfire",
      "Online: visitgulf.com/things-to-do/beaches/beach-safety"
    ]
  },
  activities: [
    {
      name: "🐢 Sea Turtle Patrol Walks",
      details: "6 AM daily, peak nesting season",
      note: "Must walk 6 miles in soft sand"
    },
    {
      name: "🛶 Dead Lakes Kayak Tours",
      details: "Bring kayaks or rent from Peachy's",
      note: "6,700 acres of cypress swamp"
    },
    {
      name: "🏰 St. Joseph Lighthouse",
      details: "Saturdays only, $5 climb",
      note: "131-step climb at George Core Park"
    },
    {
      name: "🎲 Randonautica Adventures",
      details: "Quantum exploration spots",
      note: "Dead Lakes, Buffer Preserve, Peninsula trails"
    },
    {
      name: "🚁🎣 Drone Fishing Adventure",
      details: "Drop lines 500-2000ft offshore to reach bigger fish",
      note: "Target species: TUNA (Blackfin), King Mackerel, Spanish Mackerel, Cobia, Sharks, Tarpon",
      equipment: [
        "Heavy-duty fishing drone (DJI Phantom 4/Mavic 3 for distance)",
        "Release clip rated for 15+ lbs (for tuna rigs)",
        "Heavy tackle (50-80lb line, 100lb for tuna)",
        "Circle hooks 7/0-9/0 for tuna",
        "Wire leader for toothy fish, fluorocarbon for tuna",
        "Sand spike rod holders (heavy duty)",
        "Polarized sunglasses to spot fish",
        "Fighting belt/harness for tuna"
      ],
      tips: [
        "TUNA: Need to go 1500-2000ft out to blue water",
        "Best tuna months: April-June (you're in prime time!)",
        "Tuna bait: Live cigar minnows, threadfin herring, or chunks",
        "Look for birds diving = bait balls below",
        "Watch for weed lines and color changes (green to blue)",
        "Dawn bite is best, dusk second best",
        "Stay 500ft from swimmers/surfers",
        "Check wind conditions (under 15mph ideal)",
        "Have spare batteries - expect 2-3 drops per battery",
        "Blackfin tuna run 5-30lbs in June"
      ],
      regulations: [
        "FL fishing license required (GoOutdoorsFlorida.com)",
        "Blackfin tuna: No size limit, 2 per person daily",
        "Follow FAA drone rules (400ft altitude max)",
        "Some species have size/bag limits",
        "Sharks must stay in water if caught"
      ],
      tunaSpecific: {
        title: "🐟 Tuna Tactics at Cape San Blas",
        details: [
          "Blackfin tuna patrol the 60-100ft depth range",
          "Need to fly drone 1500-2000ft to reach them",
          "They follow temperature breaks (78-82°F ideal)",
          "Look for water temp changes - check the live water temp in Weather!",
          "Run in schools - if you catch one, stay ready",
          "Fight time: 15-30 minutes on proper tackle",
          "Best action: First 2 hours after sunrise",
          "Look for 'nervous water' and jumping bait",
          "Common sizes in June: 5-30lbs (avg 10-15lbs)"
        ]
      }
    }
  ],
  emergency: {
    fire: "(850) 227-7338",
    hospital: "(850) 229-5600",
    sheriff: "(850) 227-1115"
  },
  reminders: [
    "🕰️ Girls eat by 5:30 PM",
    "🦐 Laura: No shellfish",
    "🥜 Katie: No sesame",
    "🚩 Check beach flags daily"
  ],
  hiddenGems: [
    {
      name: "🍑 Peachy's Beach Eats",
      description: "Good Food, No Service - fill out your own order card",
      note: "Cash only, amazing grouper sandwich"
    },
    {
      name: "🦅 Eagle Harbor",
      description: "Best spot for kayaking and finding whole sand dollars",
      note: "Go at low tide for best shell hunting"
    },
    {
      name: "🏖️ Jamaica Drive",
      description: "Gravel road beach cottages with direct beach access",
      note: "Less touristy, more authentic Cape experience"
    },
    {
      name: "🦐 Skully's Low Country Boil",
      description: "10-pound shrimp boils, traditional Southern seafood",
      note: "Call ahead for large groups"
    },
    {
      name: "☀️ Sunrise Cafe at WindMark",
      description: "Breakfast/lunch spot famous for homemade donuts",
      note: "Get there early - donuts sell out!"
    },
    {
      name: "🏝️ Money Bayou Beach",
      description: "Calm bayside beach perfect for kids",
      note: "Protected from waves, great for paddleboarding"
    },
    {
      name: "🎣 Salinas Park Fishing Pier",
      description: "Best sunset viewing spot on the Cape",
      note: "Free fishing, no license required on pier"
    },
    {
      name: "🌴 Cape Palms Park",
      description: "Quieter beach access south of state park",
      note: "Less crowded, ample parking"
    }
  ]
};

// Navigation sections configuration
export const NAVIGATION_SECTIONS = [
  { id: 'schedule', label: 'Schedule', icon: Calendar },
  { id: 'weather', label: 'Weather', icon: Clock },
  { id: 'property', label: 'Property', icon: Home },
  { id: 'restaurants', label: 'Dining', icon: Utensils },
  { id: 'hidden', label: 'Hidden Gems', icon: MapPin },
  { id: 'activities', label: 'Activities', icon: Waves },
  { id: 'safety', label: 'Safety', icon: AlertTriangle },
  { id: 'guests', label: 'Guests', icon: Users },
  { id: 'photos', label: 'Photos', icon: Camera }
];